module.exports = __webpack_public_path__ + "img/jtjmix.0767d7a6.jpg";